/**
 * Pauses CSS marquee animations while the tab is hidden so the browser does not
 * fast-forward the timeline and snap to a new position when the user returns.
 */
(function () {
  var MARQUEE_SELECTOR = '.brand-strip-1__wrapper, .announcement-bar__track.announcement-bar__track--ready';

  function forEachMarqueeAnimation(callback) {
    document.querySelectorAll(MARQUEE_SELECTOR).forEach(function (el) {
      el.getAnimations().forEach(callback);
    });
  }

  function syncMarqueePlayback() {
    forEachMarqueeAnimation(function (anim) {
      if (document.hidden) {
        anim.pause();
      } else {
        anim.play();
      }
    });
  }

  function restartMarquees() {
    document.querySelectorAll(MARQUEE_SELECTOR).forEach(function (el) {
      el.getAnimations().forEach(function (anim) {
        anim.cancel();
      });
      el.style.animation = 'none';
      void el.offsetWidth;
      el.style.animation = '';
      el.style.animationPlayState = '';
    });
  }

  document.addEventListener('visibilitychange', syncMarqueePlayback);

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      requestAnimationFrame(restartMarquees);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncMarqueePlayback);
  } else {
    syncMarqueePlayback();
  }

  document.addEventListener('marquee:registered', syncMarqueePlayback);

  window.syncMarqueePlayback = syncMarqueePlayback;
})();
